var React = require('react');

function Nav (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"line-1","d":"M1 0.999969H25Z","stroke":"#0B1E32","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":0}),React.createElement("path",{"className":"line-2","d":"M1 12.2416H25Z","stroke":"#0B1E32","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":1}),React.createElement("path",{"className":"line-3","d":"M1 24.0185H25Z","stroke":"#0B1E32","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":2})]);
}

Nav.defaultProps = {"className":"nav-icon-svg","width":"22","height":"22","viewBox":"0 0 26 26","fill":"none"};

module.exports = Nav;

Nav.default = Nav;
